import React from 'react'

interface Props {
  width: number
  height: number
  imgSrc: string
}

const LockPeriodLogo = ({ width, height, imgSrc }: Props) => {
  return <img width={width} height={height} src={imgSrc} alt="lock vault" />
}

export default LockPeriodLogo
